import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { history } from "../../redux-store/store";
import { connect } from "react-redux";
import { CanI } from "../../redux-store/action/permissions/permissions";
import Axios from "axios";

const TypeAhead = ({ component, CanI }) => {
  const [state, setState] = useState({
    isClearable: true,
    isDisabled: false,
    isLoading: false,
    isRtl: false,
    isSearchable: true,
    menuIsOpen: false,
    closeMenuOnSelect: false,
    options: [],
    selectedValue: ""
  });
  const [searchQuery, setSearchQuery] = useState("");

  const isMounted = useRef(false);

  const handleOnInputChange = (query, event) => {
    if (event.action === "input-change") {
      setSearchQuery(query);
    }
  };

  useEffect(() => {
    if (!isMounted.current || !searchQuery) {
      isMounted.current = true;
      return;
    }
    setState({
      ...state,
      isLoading: true
    });
    const timeoutAction = setTimeout(async () => {
      const data = await Axios.get(
        `/${component}/typeToSearch?search=${searchQuery}`
      );

      if (data) {
        setState({
          ...state,
          options: data.data,
          menuIsOpen: true,
          isLoading: false
        });
      }
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timeoutAction);
  }, [searchQuery]);

  const handleOnSelect = async (event, onClick) => {
    if (onClick.action === "clear") {
      setState({
        ...state,
        menuIsOpen: false,
        isLoading: false,
        options: []
      });
      setSearchQuery("");

      // Close Navbar
      // document.querySelector("body").click();
      return;
    }
    const verb = (await CanI(`${component}_edit`)) ? "edit" : "view";

    let prefix;
    if (history.location.pathname.startsWith("/app")) {
      prefix = "/app";
    }
    openSearchResult({
      prefix,
      component,
      verb,
      value: event.value
    });
  };

  const handleFilterOption = (option, search) => {
    if (option.label) {
      return search;
      // && option.label.toLowerCase().includes(search.toLowerCase())
    }
    return false;
  };

  const getValue = () => {
    return state.options.find(({ value }) => String(value) === selectedValue);
  };

  const {
    isClearable,
    isSearchable,
    isLoading,
    menuIsOpen,
    closeMenuOnSelect,
    isRtl,
    isDisabled,
    options,
    selectedValue
  } = state;
  return (
    <Select
      // onKeyDown={handleOnKeyDown}
      onInputChange={handleOnInputChange}
      value={getValue()}
      inputValue={searchQuery}
      className="basic-single navbar-typeahead"
      classNamePrefix="select"
      pageSize={20}
      isDisabled={isDisabled}
      isLoading={isLoading}
      closeMenuOnSelect={closeMenuOnSelect}
      menuIsOpen={menuIsOpen}
      isClearable={isClearable}
      isRtl={isRtl}
      isSearchable={isSearchable}
      name={"search_query"}
      options={options}
      onChange={handleOnSelect}
      filterOption={handleFilterOption}
      onBlur={() => {}}
    />
  );
};
export default connect(null, { CanI })(TypeAhead);

function openSearchResult({ prefix, component, verb, value }) {
  if (prefix) {
    window.location.href = `${prefix}/${component}/${verb}/${value}`;
  } else {
    window.location.href = `/${component}/${verb}/${value}`;
  }
}
